var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"p-4 bg-white border-t border-solid border-base-400"},[_c('div',{class:[_vm.data.class, _vm.data.staticClass, 'mx-auto max-w-screen-2xl']},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }